import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { getAppDataOptions } from 'hooks/data/useAppData';

import { LoginView } from 'views/LoginView/LoginView';

const searchSchema = z.object({
  state: z.enum(['login', 'forgot', 'register', 'magic', 'quick']).default('login'),
  action: z.enum(['login', 'logout']).optional(),
  redirect: z.string().optional(),
});

export { searchSchema as loginSearchSchema };

export type LoginSearchSchema = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/_auth/login')({
  component: LoginView,
  loader: async ({ context: { queryClient } }) => {
    return queryClient.ensureQueryData(getAppDataOptions({ id: '760' }));
  },
  validateSearch: (search) => {
    return searchSchema.parse(search);
  },
});
